import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from 'mobx-react';
import { BtwButton } from '@marvelapp/ballpark-components';
import { SplitIcon } from '@marvelapp/ballpark-icons';
export const PathsButton = observer(function PathsButton(props) {
    return (_jsx(BtwButton, Object.assign({ "data-testid": "open-paths", leadingIcon: _jsx(SplitIcon, {}) }, props, { children: "Paths & Heatmaps" })));
});
